<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>回访任务统计</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        :model="query"
      >
        <el-form-item label="年份">
          <el-date-picker
            v-model="yearStr"
            type="year"
            value-format="yyyy"
            placeholder="选择年份"
            @change="yearSearch();"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="yearSearch();">查询</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="24">
        <el-col :span="10">
          <el-card class="box-card collectCard" shadow="always" style="margin-top:20px;">
            <div class="clearfix" slot="header">
              <span>月统计</span>
            </div>
            <div class="index-card" style="height:auto;">
              <el-table
                :data="monthData"
                stripe
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="name" label="月份"></el-table-column>
                <el-table-column prop="count" label="任务数量"></el-table-column>
                <el-table-column label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group v-if="scope.row.count>0">
                      <el-tooltip content="查看" placement="top">
                        <el-button type="primary" size="mini" icon="el-icon-view"
                          @click="monthSearch(scope.row);"></el-button>
                      </el-tooltip>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="2" style="color:#f56c6c; text-align:center;">
          <div style="height:300px;"></div>
          <i class="el-icon-d-arrow-right"></i>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card collectCard" shadow="always" style="margin-top:20px;">
            <div class="clearfix" slot="header">
              <span>日统计 ({{monthStr}})</span>
            </div>
            <div class="index-card" style="height:auto;">
              <el-table
                :data="dayData"
                stripe
                style="width: 100%"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="name" label="日期"></el-table-column>
                <el-table-column prop="count" label="任务数量" sortable></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      domain: url.getDomain(),
      query: {}, //对象
      loading: false,
      monthData: [],
      dayData: [],
      yearStr: "",
      monthStr: ""
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.count > 0) {
        return "success-row";
      }
      return "";
    },
    //获取月份统计
    getMonth() {
      var _this = this;
      var link = url.getCollect("GetVisitByYear");
      $.get(link, { year: _this.yearStr }, data => {
        _this.monthData = data;
        _this.dayData = [];
      });
    },
    yearSearch() {
      this.getMonth();
    },
    //查看月份
    monthSearch(row) {
      var _this = this;
      var month = row.name.replace("月", "");
      var link = url.getCollect("GetVisitByMonth");
      this.monthStr = row.name;
      $.get(link, { time: _this.yearStr + "-" + month }, data => {
        _this.dayData = data;
      });
    }
  },
  created() {},
  mounted() {
    var _this = this;
    _this.yearStr = new Date().getFullYear().toString();
    this.getMonth();
  }
};
</script>

<style >
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.el-table .success-row td {
  background: inherit !important;
}
</style>
